document.addEventListener('DOMContentLoaded', function() {
  const lang = document.documentElement.lang;
  
  if (lang === 'fr') {
    
    function translateRecommendations() {
      const recommendationsSection = document.querySelector('.product-recommendations__slideshow');
      
      if (recommendationsSection) {
        // Fix product links - add /fr prefix
        const productLinks = document.querySelectorAll('.product-page-related-products a[href*="/products/"]');
        
        productLinks.forEach(function(link) {
          const href = link.getAttribute('href');
          if (href && !href.includes('/fr/') && href.startsWith('/products/')) {
            link.setAttribute('href', '/fr' + href);
            
            // Fetch the French product title from the French product page
            const frenchUrl = '/fr' + href;
            fetch(frenchUrl)
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const frenchTitle = doc.querySelector('h1, .product-title, [itemprop="name"]');
                
                if (frenchTitle) {
                  // Update the product title in the grid
                  const titleElement = link.closest('.grid-view-item').querySelector('.product-grid--title a');
                  if (titleElement) {
                    titleElement.textContent = frenchTitle.textContent.trim();
                  }
                }
              });
          }
        });
        
        // Translate section heading if needed
        const heading = document.querySelector('.product-page-related-products .page--title');
        if (heading && heading.textContent.trim() === 'You may also like') {
          heading.textContent = 'Vous aimerez peut-être aussi';
        }
      }
    }
    
    // Run after owl carousel loads
    setTimeout(translateRecommendations, 1000);
    setTimeout(translateRecommendations, 2000);
  }
});
